<div class="banner" [class]="image">

</div>
